import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { HomeDailyLessonSaboIcon } from '@lean-body/components/atoms';
import { Colors } from '@lean-body/components/styles';
export const HomeDailyLessonVolumeIntro = ({ classObject }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("div", { className: css(styles.saboColumn) },
            React.createElement(HomeDailyLessonSaboIcon, null),
            React.createElement("span", { className: css(styles.saboLabel) }, "sabo")),
        React.createElement("div", { className: css(styles.speechBubble) },
            React.createElement("p", { className: css(styles.speechBubbleText) },
                "AI",
                React.createElement("br", null),
                "\u30C7\u30A4\u30EA\u30FC\u30EC\u30C3\u30B9\u30F3\u3092",
                React.createElement("br", null),
                "\u59CB\u3081\u3088\u3046\uFF01"))));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 9,
        marginBottom: 16,
    },
    saboColumn: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 6,
        width: 68,
        flexShrink: 0,
    },
    saboLabel: {
        alignSelf: 'stretch',
        fontSize: 10,
        fontWeight: 400,
        lineHeight: 1,
        letterSpacing: 0.8,
        textAlign: 'center',
        color: Colors.Black,
    },
    speechBubble: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: 8,
        paddingRight: 14,
        paddingBottom: 8,
        paddingLeft: 14,
        borderRadius: 30,
        backgroundColor: Colors.White,
    },
    speechBubbleText: {
        margin: 0,
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1.4,
        letterSpacing: 0.56,
        textAlign: 'center',
        color: Colors.Black,
    },
});
